"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSLinkingModalComponent = void 0;
const core_1 = require("@angular/core");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
class CSLinkingModalComponent {
    constructor(modalService) {
        this.modalService = modalService;
    }
    closeModal() {
        this.modalReference.close();
    }
    open(content) {
        this.modalReference = this.modalService.open(content, { windowClass: 'dark-modal' });
    }
    showFiberWirelessLinkModel() {
        this.modalReference.close();
        this.open(this.fiberWirelessAccountLinking);
    }
}
exports.CSLinkingModalComponent = CSLinkingModalComponent;
//# sourceMappingURL=linkingmodal.component.js.map